$(document).ready(function () {
    function formatMoney(cents, format) {
        if (typeof cents == 'string') { cents = cents.replace('.', ''); }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || this.money_format);

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) { return 0; }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        var match = formatString.match(placeholderRegex);

        if (match) {
            switch (match[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
            }
        }

        return formatString.replace(placeholderRegex, value);
    };



    function updateTotalPrice(quantity, leftPrice, rightPrice) {
        const incrementValueLeft = $('.product-calculator-left__product--slider .slick-current').data('increment-price');
        const incrementValueRight = $('.product-calculator-right__product--slider .slick-current').data('increment-price');
        const dynamicLeftTotal = incrementValueLeft ? (leftPrice + (incrementValueLeft * (quantity - 1))) : leftPrice * quantity;
        const dynamicRightTotal = incrementValueRight ? (rightPrice + (incrementValueRight * (quantity - 1))) : rightPrice * quantity;

        $('.price__left--total').text(formatMoney(dynamicLeftTotal, theme.settings.moneyFormat));
        $('.price__right--total').text(formatMoney(dynamicRightTotal, theme.settings.moneyFormat));

        if (quantity === 1) {
            $('.price__disclaimer').addClass('hide');
        } else {
            $('.price__disclaimer').removeClass('hide');
        }
    }


    const numLeftItems = $('.product-calculator-left__product--slider .product-calculator-product__details-slider--item').length;
    $('.product-calculator-left__product--slider').slick({
        slidesToShow: 1,
        infinite: false,
        dots: numLeftItems > 1,
        prevArrow: $('.product-calculator-navigation__arrow--prev'),
        nextArrow: $('.product-calculator-navigation__arrow--next'),
        appendDots: $('.product-calculator-navigation__dots')
    });


    const numRightItems = $('.product-calculator-right__product--slider .product-calculator-product__details').length;
    $('.product-calculator-right__product--slider').slick({
        slidesToShow: 1,
        infinite: false,
        dots: numRightItems > 1,
        prevArrow: $('.product__right.product-calculator-navigation__arrow--prev'),
        nextArrow: $('.product__right.product-calculator-navigation__arrow--next'),
        appendDots: $('.product__right .product-calculator-navigation__dots-right')
    });


    $('#product-calculator-input__value').on('input change', function () {
        const quantity = Math.max(1, parseInt($(this).val(), 10) || 1);
        const currentLeftPrice = parseFloat($('.product-calculator-left__product--slider .slick-current').data('price'));
        const currentRightPrice = parseFloat($('.product-calculator-right__product--slider .slick-current').data('price'));
        updateTotalPrice(quantity, currentLeftPrice, currentRightPrice);
    });

    $('.product-calculator-button__minus, .product-calculator-button__plus').on('click', function () {
        const quantityInput = $('#product-calculator-input__value');
        let quantity = parseInt(quantityInput.val(), 10);
        const isAdding = $(this).hasClass('product-calculator-button__plus');
        quantity = isAdding ? quantity + 1 : Math.max(1, quantity - 1);

        const incrementValueLeft = $('.product-calculator-left__product--slider .slick-current').data('increment-price');
        const incrementValueRight = $('.product-calculator-right__product--slider .slick-current').data('increment-price');

        const incrementValue = incrementValueLeft || incrementValueRight;

        const currentLeftPrice = parseFloat($('.product-calculator-left__product--slider .slick-current').data('price'));
        const currentRightPrice = parseFloat($('.product-calculator-right__product--slider .slick-current').data('price'));

        quantityInput.val(quantity);
        updateTotalPrice(quantity, currentLeftPrice, currentRightPrice, incrementValue);
    });


    function onSlideChange(sliderSide) {
        const quantityInput = $('#product-calculator-input__value');
        quantityInput.val(1);
        const quantity = 1;

        const currentLeftPrice = parseFloat($('.product-calculator-left__product--slider .slick-current').data('price'));
        const currentRightPrice = parseFloat($('.product-calculator-right__product--slider .slick-current').data('price'));

        if (sliderSide === 'left') {
            updateTotalPrice(quantity, currentLeftPrice, currentRightPrice);
        } else {
            updateTotalPrice(quantity, currentLeftPrice, currentRightPrice);
        }
    }

    $('.product-calculator-left__product--slider').on('afterChange', function (event, slick, currentSlide) {
        onSlideChange('left');
    });

    $('.product-calculator-right__product--slider').on('afterChange', function (event, slick, currentSlide) {
        onSlideChange('right');
    });

    const initialLeftPrice = parseFloat($('.product-calculator-left__product--slider .product-calculator-product__details-slider--item').first().data('price'));
    const initialRightPrice = parseFloat($('.product-calculator-right__product--slider .product-calculator-product__details-slider--item').first().data('price'));

    updateTotalPrice(1, initialLeftPrice, initialRightPrice);
});
